import React from 'react';

function NavLink({ href, tab, activeTab, baseClass, activeClass, children, setTab }) {
  const className = tab == activeTab ? activeClass : baseClass;
  return (
    <a href={href}
       onClick={(e) => {
         setTab(tab);
       }}
       className={className}
    >
      { children }
    </a>
  )
}

export  default NavLink;
